import makeStyles from '@mui/styles/makeStyles';
import { Theme } from "@mui/material";
import { placeholderColor } from "../DashStyleGuides";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100%",
  },
  lblNoData: {
    fontFamily: "Manrope",
    color: placeholderColor,
    fontSize: 16,
    fontWeight: 700,
    marginTop: 16,
  },
  bxMargin: {
    marginTop: "7%",
  },
}));
